<template>
  <DesktopVersion
    class="mb-32 hidden md:block"
    :initial-values
    :page-type
    :status-filter-option
    @apply-filters="handleApplyFilters"
  />

  <MobileVersion
    class="md:hidden"
    :initial-values
    :page-type
    :status-filter-option
    @apply-filters="handleApplyFilters"
  />
</template>

<script setup lang="ts">
import { sellerCustomerCareAPI } from '@backmarket/http-api'

import DesktopVersion from './DesktopVersion/DesktopVersion.vue'
import MobileVersion from './MobileVersion/MobileVersion.vue'

defineProps<{
  pageType: string
  statusFilterOption: Array<sellerCustomerCareAPI.FilterOptionItem>
  initialValues: sellerCustomerCareAPI.Filter
}>()

const emit = defineEmits(['apply-filters'])

function handleApplyFilters(values: sellerCustomerCareAPI.Filter) {
  emit('apply-filters', values)
}
</script>
